import React from 'react';
import Link from 'next/link';
import { Button, Chip, colors } from '@itandi/itandi-bb-ui';
import { toast } from 'react-toastify';
import Styles from './DealMainSpLinks.module.scss';
import { PATH as DEAL_DETAIL_PATH } from '~/pages/deals/[id]/detail';
import { PATH as DEAL_MESSAGES_PATH } from '~/pages/deals/[id]/messages';
import { useDeals } from '~/hooks/useDeals';
import { isWithVendorDeal } from '~/models/Deal';
import { getOriginVendor } from '~/models/DealVendorCompany';
import { useMessages } from '~/hooks/deals/useMessages';
import {
  getUnreadCount,
  UPDATE_TEMPORARY_UNREAD_MESSAGE
} from '~/models/Message';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';
import { isSuccess } from '~/utils/api/api_handler';
import { postTemporaryUnread } from '~/utils/api/deals/Message';
import { SERVER_ERROR_MESSAGE } from '~/constants/AppConst';

type Props = {
  isAdmin: boolean;
};

export const DealMainSpLinksClient: React.FC<Props> = ({ isAdmin }: Props) => {
  const id = useIdQueryHandler();
  const { data: deal, mutate: mutateDeal } = useDeals().show(id);
  const { data: messages } = useMessages().index(id);
  const unreadMessageCount = React.useMemo((): number => {
    if (messages === null) {
      return 0;
    }
    return getUnreadCount(messages, 'maintenance_company');
  }, [messages]);
  if (deal === null) {
    return null;
  }
  const handleTemporaryUnread = async (): Promise<void> => {
    const result = await postTemporaryUnread(deal.id);
    if (isSuccess(result)) {
      toast.success(UPDATE_TEMPORARY_UNREAD_MESSAGE);
      mutateDeal && (await mutateDeal());
      return;
    }
    toast.error(SERVER_ERROR_MESSAGE);
  };
  const unread =
    !!deal.messageSummaryUnread?.unread ||
    !!deal.messageSummaryUnread?.displayUnread;
  const unreadChipText =
    unreadMessageCount > 0 ? `未読${unreadMessageCount}` : '未読';
  return (
    <div className={Styles.SPDealDetail}>
      <Link
        className={Styles.SPDealDetailLink}
        href={DEAL_DETAIL_PATH(deal.id)}
      >
        案件内容
      </Link>
      {isWithVendorDeal(deal) && getOriginVendor(deal) !== null && (
        <>
          <Link
            className={Styles.SPDealDetailLink}
            href={DEAL_MESSAGES_PATH(deal.id)}
          >
            施工会社とチャット
            {unread && (
              <Chip
                background={colors['semantic-negative']}
                borderColor={null}
                label={unreadChipText}
                textColor={colors['itandi-white']}
              />
            )}
          </Link>
          {messages && messages.length > 0 && !unread && (
            <Button
              disabled={isAdmin}
              marginTop="1rem"
              onClick={handleTemporaryUnread}
              variant="tertiary"
              width="fill"
            >
              チャットに未読ラベルを付ける
            </Button>
          )}
        </>
      )}
    </div>
  );
};
